import { FormControl, FormHelperText, InputLabel, OutlinedInput } from "@mui/material";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { IMaskInput } from "react-imask";

/**
 * CPFMaskedInputBase
 */
interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const CNPJMaskedInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      inputRef={refs}
      onAccept={(value: any, input: { unmaskedValue: string }) => {
        if (input.unmaskedValue.length > 0) {
          onChange({ target: { name: props.name, value } });
        } else {
          onChange({ target: { name: props.name, value: '' } });
        }
      }}
      lazy={false}
      overwrite={true}
    />
  );
});


/**
 * CNPJMaskedInput
 */

type Props = {
  name: string,
  label: string,
  error?: boolean,
  helperText?: string,
  value?: string;
  placeholder?: string;
  unmask?: boolean;
  lazy?: boolean;
  autofix?: boolean;
  onChange: (value: string) => void,
};

export const CNPJMaskedInput = ({
  name,
  label,
  error,
  helperText,
  value,
  placeholder,
  unmask,
  onChange,
}: Props) => {
  const [fieldValue, setFieldValue] = useState(value);

  useEffect(() => {
    setFieldValue(value);
  }, [
    value,
  ]);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(event.target.value);
    onChange(event.target.value);
  }, [onChange]);

  return (
    <FormControl variant="outlined" size="small">
      <InputLabel htmlFor={`input-${name}`} shrink={true} size="small" error={error}>{label}</InputLabel>
      <OutlinedInput
        size="small"
        id={`input-${name}`}
        name={name}
        value={fieldValue ?? null}
        label={label}
        notched={true}
        error={error}
        aria-describedby={`${name}-component-error-text`}
        onChange={handleChange}
        inputComponent={CNPJMaskedInputBase as any}
        inputProps={{
          mask: '00.000.000/0000-00',
          placeholder: placeholder ?? '_',
          unmask,
        }}
      />

      <FormHelperText id={`${name}-component-error-text`} error={error}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}